import { GetCounterpartiesQuery } from "@common/schemas/counterparty.schema";
import { FiltersTypes } from "@common/types/filters/general";

type CounterpartiesDirectoryQueryFilters = Pick<
    GetCounterpartiesQuery,
    | "coaAccountIds"
    | "financialAccountIds"
    | "minAmount"
    | "maxAmount"
    | "amountDirection"
    | "amountRounded"
    | "amountRoundingLevel"
    | "isEligible1099"
    | "shouldExcludeCreditCardJournalEntries"
    | "shouldExcludePaymentProcessorJournalEntries"
    | "includeExcludedAmounts"
    | "journalEntrySources"
    | "amountFilterLevel"
    | "createdByKick"
    | "createdByUserIds"
    | "createdBySources"
    | "accountClasses"
>;

export function toCounterpartiesDirectoryQueryFilters(
    filters: FiltersTypes,
): CounterpartiesDirectoryQueryFilters {
    return {
        coaAccountIds: filters.coaAccounts,
        financialAccountIds: filters.accountIds,
        minAmount: filters.minAmount,
        maxAmount: filters.maxAmount,
        amountDirection: filters.direction,
        amountRounded: filters.amountRounded,
        amountRoundingLevel: filters.amountRoundingLevel,
        isEligible1099: filters.isEligible1099,
        shouldExcludeCreditCardJournalEntries:
            filters.shouldExcludeCreditCardJournalEntries,
        shouldExcludePaymentProcessorJournalEntries:
            filters.shouldExcludePaymentProcessorJournalEntries,
        includeExcludedAmounts: filters.includeExcludedAmounts,
        journalEntrySources: filters.journalEntrySources,
        amountFilterLevel: filters.amountFilterLevel,
        createdByKick: filters.createdByKick,
        createdByUserIds: filters.createdByUserIds,
        createdBySources: filters.createdBySources,
        accountClasses: filters.accountClasses,
    };
}
